
<template>
  <!-- company-info-view .civ -->
  <div class="civ">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>供需审核</BreadcrumbItem>
          <BreadcrumbItem>企业供需审核</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">企业供需审核</div>
      </div>
    </div>
    <div class="header-switch">
      <div class="header-switch-text">对企业供需信息进行审核</div> 
    </div>
    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="待审核" name="1"> 
          <supplyCompanyCheck ref="supplyCompanyCheck" v-if="String(showTabs) === '1'" />
        </TabPane>
        <TabPane label="未通过" name="2"> 
          <supplyCompanyPass ref="supplyCompanyPass" v-if="String(showTabs) === '2'" />
        </TabPane> 
      </Tabs>
    </div>
  </div>
</template>

<script>
import supplyCompanyCheck from "./subpages/supply-company-check.vue";
import supplyCompanyPass from "./subpages/supply-company-pass.vue"; 

export default {
  name: "host-supply-company",
  data() {
    return {
      showTabs: "1",
      show: false,
      allDone: "待处理"
    };
  },
  components: {
    supplyCompanyCheck,
    supplyCompanyPass, 
  },
  created() {
    this.changeTab();
  },
  methods: {
    changeTab() {
      let query = this.$route.query;
      if (query && query.type && query.type === "check") {
        this.showTabs = "1";
      } else if (query && query.type && query.type === "pass") {
        this.showTabs = "2";
      } 
    },
    switchBrand(name) { 
      if (name === "1") {
        this.$router.push(`${this.$route.path}?type=check`);
      } else if (name === "2") {
        this.$router.push(`${this.$route.path}?type=pass`);
      } 
    },
    showAdd(name) {
      this.$refs[name].showAdd();
    }
  }
};
</script>

<style scoped lang="scss">
.header-switch {
  display: flex;
  align-items: center;
  padding: 0 35px 18px 35px;
  background: #fff;
  &-text {
    flex: 1;

    font-size: 14px;
    color: #808080;
  }
  &-box {
    flex: 1;
    text-align: right;
  }
}
</style>
